module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VUcnZY/tc-custom/9781035847860.jpg?1727443965365",
      "alt": "This image is the cover for the book Colour Coded: The White Wire"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Colour Coded: The White Wire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Following the events in Bridge of Orchy, Colour Coded returns to action as The White Wire must revisit his family home to confirm if the woman Neon murdered was indeed his sister. As the story unfolds, Colour Coded discovers another gang intertwined with Neon’s world, and The Yellow Youth quickly realizes his personal connection to one of its members. Forming an alliance may be their only hope to stop Neon. However, in just a few hours, Colour Coded’s mission shifts from tracking and killing Neon to preventing a bomb from annihilating an unsuspecting village – a bomb that Neon has arranged for Colour Coded to be blamed for. Gang warfare, kidnapping, murder… and now terrorism. Neon will stop at nothing in his psychotic rage against his former team. Can Colour Coded set aside their personal issues long enough to prevent the bomb from detonating? Or will Neon’s mind games lead to fatal consequences?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Katy Jordan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Katy Jordan is a multi-award-winning filmmaker who hails from Stirling while currently living in Glasgow. Since a young age, Katy has dreamed of being a writer and actress and, for the last ten years, has been actively pursuing both endeavours.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0